<template>
  <div>
    <v-container>
      <v-btn
        color="primary"
        to="/samples/sample-wizard"
        @click="clearActive"
        class="ma-5"
        v-if="!user.is_copy_to"
      >
        Submit New Sample
      </v-btn>
      <v-btn color="primary" to="/samples/browse" class="ma-5">
        Samples Browse
      </v-btn>
      <v-btn
        v-if="!user.is_copy_to"
        color="primary"
        to="/farms/browse"
        class="ma-5"
      >
        Farms Browse
      </v-btn>
      <v-btn
        color="primary"
        to="/copy-to/browse"
        class="ma-5"
        v-if="!user.is_copy_to"
      >
        Recipients Browse
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "DashboardShortcuts",
  methods: {
    ...mapMutations("samples", ["clearActive"])
  },
  computed: {
    ...mapFields("auth", ["user"])
  }
};
</script>
